function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 1h30v30H1V1z",
  stroke: "#4B4B4B",
  fill: "#D8D8D8",
  strokeDasharray: 3
}), /*#__PURE__*/React.createElement("text", {
  fontFamily: "NotoSans-Bold, Noto Sans",
  fontSize: 8,
  fontWeight: "bold",
  fill: "#4B4B4B",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 4.459,
  y: 19
}, "ICON")));
function SvgRoofToggle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgRoofToggle;